import {formatter, request} from "@/utils/request";

export namespace Report {
  export const Path = {
    Generate: "/fileapi/downloadCenter/generate",
  }

  export async function generate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    };
    return request<API.ResponseResult<any>>(Path.Generate, formatter(options));
  }

}
